import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Breadcrumb, Card, Table } from "react-bootstrap";
import { Button } from "primereact/button";
import { Image } from 'primereact/image';
import { Avatar } from 'primereact/avatar';
import { Badge } from 'primereact/badge';
import { InputSwitch } from "primereact/inputswitch";
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import GifLoder from '../../components/GifLoder';
import { useAuth } from '../../context/AuthContext';
import config from '../../config';
import { getSocket } from '../../context/socket'; // adjust path as needed
import axios from 'axios';
import { Toast } from "primereact/toast";
import CustomConfirmPopup from "../../components/CustomConfirmPopup";
const Adminwishlist = () => {
    const { accessToken, userId, role, username } = useAuth();
    const socket = getSocket();
    const [checked, setChecked] = useState(true);
    const [visible, setVisible] = useState(false);
    const [date, setDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);
    const [eventData, setEventData] = useState(null);
    const [eventStatus, setEventStatus] = useState(null);
    const [participants, setParticipants] = useState([]);
    const [drawData, setDrawData] = useState([]);





    useEffect(() => {
        if (!socket) return;
        setLoading(true);

        const fetchEventData = () => {
            setLoading(true);
            socket.emit("adminFetchSantaEventData");
        };

        // --- LISTENERS ---
        const handleEventData = (data) => {
            if (data.status === "success") {
                setEventData(data.eventdata);
                setEventStatus(data.eventdata.is_active);
            } else {
                setEventData(null);
                setEventStatus(null);
            }

            setLoading(false); // 🔥 stop loading once data arrives
        };

        const handleEventUpdated = () => {
            fetchEventData(); // auto refresh
        };

        socket.on("adminSantaEventData", handleEventData);
        socket.on("adminSantaEventUpdated", handleEventUpdated);

        // First call
        fetchEventData();

        return () => {
            socket.off("adminSantaEventData", handleEventData);
            socket.off("adminSantaEventUpdated", handleEventUpdated);
        };
    }, [socket]);

    useEffect(() => {
        if (!socket || !eventData?.event_id) return;

        setLoading(true);

        socket.emit("fetchSantaEventData", { event_id: eventData.event_id });

        socket.on("santaEventData", (data) => {
            if (data.success) {
                setParticipants(data.participants);
            } else {
                setParticipants([]);
            }
            setLoading(false);
        });

        return () => {
            socket.off("santaEventData");
        };
    }, [socket, eventData]);

    useEffect(() => {
        if (!socket || !eventData?.event_id) return;

        socket.on("santaUpdated", () => {
            // 🔄 refetch updated participants list
            socket.emit("fetchSantaEventData", { event_id: eventData.event_id });
        });

        return () => {
            socket.off("santaUpdated");
        };
    }, [socket, eventData]);


    useEffect(() => {
        if (!socket || !eventData?.event_id) return;

        setLoading(true);

        const fetchDrawData = () => {
            socket.emit("adminFetchSantaDrawData", { event_id: eventData.event_id });
        };

        // Initial fetch
        fetchDrawData();

        // Handler for draw data
        const handleSantaDrawData = (data) => {
            if (data.success) {
                setDrawData(data.data);
            } else {
                setDrawData([]);
            }
            setLoading(false);
        };

        // Handler for update events
        const handleDrawUpdated = () => {
            fetchDrawData(); // re-fetch whenever pairs are updated
        };

        socket.on("adminSantaDrawData", handleSantaDrawData);
        socket.on("santadrawUpdated", handleDrawUpdated);

        return () => {
            socket.off("adminSantaDrawData", handleSantaDrawData);
            socket.off("santadrawUpdated", handleDrawUpdated);
        };
    }, [socket, eventData]);



    if (loading) {
        return (
            <div className="loderDiv">
                <GifLoder />
            </div>
        );
    }

    const handleAddEvent = async () => {
        if (!date) {
            toast.current.show({
                severity: "warn",
                summary: "Year Missing",
                detail: "Please select a year!"
            });
            return;
        }

        const year = date.getFullYear();

        try {
            setLoading(true);

            const response = await axios.post(
                `${config.apiBASEURL}/SecretSantaRoutes/event`,
                {
                    year,
                    is_active: false
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json"
                    }
                }
            );
            if (response.status === 201) {

                // Close dialog & clear values
                setVisible(false);
                setDate(null);
            }
        } catch (err) {
            console.error("Error creating event:", err);
        } finally {
            setLoading(false);
        }
    };


    const eventStart = async () => {
        if (!eventData?.event_id) {
            toast.current.show({
                severity: "warn",
                summary: "No Event Selected",
                detail: "Please select an event first!",
            });
            return;
        }

        try {
            setLoading(true);

            const response = await axios.post(
                `${config.apiBASEURL}/SecretSantaRoutes/generatePairs/${eventData.event_id}`,
                {}, // no body needed
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
            }
        } catch (err) {
            console.error("Error generating pairs:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteParticipant = async (participant_id) => {
        if (!participant_id) return;

        try {
            setLoading(true);

            const response = await axios.delete(
                `${config.apiBASEURL}/SecretSantaRoutes/santa-participant/delete/${participant_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.status === 200) {
                toast.current.show({
                    severity: "success",
                    summary: "Deleted",
                    detail: "Participant removed successfully!",
                });

                // ⬇️ Remove from UI without reloading page
                setParticipants((prev) =>
                    prev.filter((p) => p.participant_id !== participant_id)
                );
            }
        } catch (err) {
            console.error("Error deleting participant:", err);

            toast.current.show({
                severity: "error",
                summary: "Failed",
                detail: err.response?.data?.message || "Delete failed",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <Row className="body_content">
                <Row className="mx-0">
                    <Col sm={12} xs={12} className="mb-3 d-lg-flex justify-content-between align-items-center">
                        <Breadcrumb>
                            <Breadcrumb.Item active>Secret Santa</Breadcrumb.Item>
                        </Breadcrumb>

                        <Button
                            label="Start Now"
                            severity="help"
                            className="py-2"
                            onClick={eventStart}
                        />

                    </Col>
                    <Row className="mx-0 mt-4">
                        <Col lg={8} className="px-2 mb-3">
                            <Card className="santaTABLE">
                                <Card.Header className="bg-transparent h6" style={{ height: '52px' }}>
                                    Wishlist
                                </Card.Header>
                                <Card.Body>
                                    <Table size="sm" bordered hover responsive className="wishTable">
                                        <thead>
                                            <tr className="table-info">
                                                <th style={{ width: '60px' }}>#</th>
                                                <th style={{ width: '220px' }}>User Name</th>
                                                <th style={{ width: '100px' }}>Gift Image</th>
                                                <th scope="col" >Gift URL</th>
                                                <th style={{ width: '60px' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {participants.length > 0 ? (
                                                participants.map((p, index) => (
                                                    <tr key={p.participant_id}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <span className="d-flex align-items-center gap-2">
                                                                <Avatar image={p.participantUser?.profileImage?.image_url} shape="circle" />
                                                                <span>
                                                                    {p.participantUser?.first_name} {p.participantUser?.last_name}
                                                                </span>
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <Image
                                                                src={p.image_url}
                                                                zoomSrc={p.image_url}
                                                                alt="gift"
                                                                width="40"
                                                                height="40"
                                                                preview
                                                            />
                                                        </td>

                                                        <td>
                                                            <div class="url-wrapper">
                                                                <a class="two-line-ellipsis" href={p.amazon_url} target="_blank" rel="noopener noreferrer">
                                                                    {p.amazon_url}
                                                                </a>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <CustomConfirmPopup
                                                                message="Are you sure you want to delete this gift record?"
                                                                icon="pi pi-exclamation-triangle"
                                                                defaultFocus="accept"
                                                                acceptClassName="p-button-danger"
                                                                buttonLabel="Delete"
                                                                title="Delete Gift Record"
                                                                buttonClass="p-button-danger p-button-text"
                                                                className="border-0 p-0"
                                                                buttonIcon="pi pi-trash"
                                                                onConfirm={() => handleDeleteParticipant(p.participant_id)}
                                                                onReject={() => console.log('Delete action canceled')}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No participants found</td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </Table>

                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} className="px-2 mb-3">
                            <Card className="santaTABLE santabg2">
                                <Card.Header className="bg-transparent h6 d-flex justify-content-between align-items-center">
                                    Event Select
                                    <Button
                                        label="Add Event"
                                        severity="danger"
                                        className="py-1 "
                                        onClick={() => setVisible(true)}
                                    />
                                </Card.Header>
                                <Card.Body>
                                    <Table size="sm" bordered hover responsive>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Event Year</th>
                                                <th style={{ width: '120px' }}>Status</th>
                                                <th style={{ width: '90px' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {eventData ? (
                                                <tr>
                                                    <td>1</td>
                                                    <td>{eventData.year}</td>

                                                    <td>
                                                        <Badge
                                                            value={eventStatus ? "Active" : "Inactive"}
                                                            severity={eventStatus ? "success" : "danger"}
                                                        />
                                                    </td>

                                                    <td>
                                                        <InputSwitch
                                                            checked={eventStatus}
                                                            onChange={(e) => {
                                                                setEventStatus(e.value);

                                                                // Send update to backend
                                                                socket.emit("updateSantaEventStatus", {
                                                                    event_id: eventData.event_id,
                                                                    active: e.value
                                                                });
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center">
                                                        No Event Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                    <div className="d-flex justify-content-between">
                                        <img src="https://blackboxstorage.blr1.cdn.digitaloceanspaces.com/assetImages/santa.gif" alt="Santa" className="m-auto" style={{ height: '190px', width: '190px', marginTop: '0px', }} />
                                        {/* <img src="https://blackboxstorage.blr1.cdn.digitaloceanspaces.com/assetImages/santa.gif" alt="Santa" className="m-auto" style={{ height: '190px', marginTop: '0px', }} /> */}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={12} className="px-2 mb-3">
                            <Card className="santaTABLE">
                                <Card.Header className="bg-transparent h6 d-flex justify-content-between align-items-center">
                                    Matching details
                                </Card.Header>
                                <Card.Body>
                                    <Table size="sm" bordered hover responsive>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '90px' }}>#</th>
                                                <th style={{ width: '120px' }}>Event Year</th>
                                                <th style={{ width: '300px' }} className="text-center">Match to</th>
                                                <th style={{ width: '90px' }}>Gift Image</th>
                                                <th>Gift URL</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {drawData.length > 0 ? (
                                                drawData.map((p, index) => (
                                                    <tr key={p.ssd_id}>
                                                        <td>{index + 1}</td>
                                                        <td>{eventData?.year}</td>
                                                        <td>
                                                            <div className="d-flex gap-5 justify-content-center">
                                                                {/* Giver */}
                                                                <div className="d-flex flex-column gap-2 align-items-center">
                                                                    <Avatar
                                                                        image={p.giverUser?.profileImage?.image_url}
                                                                        shape="circle"
                                                                    />
                                                                    <span>
                                                                        {p.giverUser?.first_name}
                                                                    </span>
                                                                </div>

                                                                {/* Receiver */}
                                                                {p.receiverUser ? (
                                                                    <div className="d-flex flex-column gap-2 align-items-center">
                                                                        <Avatar
                                                                            image={p.receiverUser?.profileImage?.image_url}
                                                                            shape="circle"
                                                                        />
                                                                        <span>
                                                                            {p.receiverUser?.first_name}
                                                                        </span>
                                                                    </div>
                                                                ) : (
                                                                    <span>Not Assigned</span>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {p.image_url ? (
                                                                <Image
                                                                    src={p.image_url}
                                                                    zoomSrc={p.image_url}
                                                                    alt="gift"
                                                                    width="40"
                                                                    height="40"
                                                                    preview
                                                                />
                                                            ) : (
                                                                <span>N/A</span>
                                                            )}
                                                        </td>

                                                        <td>
                                                            <div class="url-wrapper">
                                                                {p.amazon_url ? (
                                                                    <a href={p.amazon_url} target="_blank" class="two-line-ellipsis" rel="noopener noreferrer">
                                                                        {p.amazon_url}
                                                                    </a>
                                                                ) : (
                                                                    <span>N/A</span>
                                                                )}
                                                            </div>

                                                        </td>


                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No matches found</td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </Table>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Row>
            </Row>

            <Dialog header="Select Event Year" visible={visible} style={{ width: '350px' }} onHide={() => { if (!visible) return; setVisible(false); }}>
                <div className="d-flex flex-column gap-2">
                    <label className="mb-2">Select Event Year</label>
                    <Calendar value={date} onChange={(e) => setDate(e.value)} view="year" dateFormat="yy" className="w-100"
                        minDate={new Date()}
                        maxDate={new Date()} // ⬅️ prevents selecting future years
                    />
                </div>
                <Button
                    label="Submit"
                    severity="danger"
                    className="py-2 mt-4 w-100"
                    onClick={handleAddEvent}
                />

            </Dialog>
        </>
    );
};

export default Adminwishlist;
